import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/slice";
import _Array$from from "@babel/runtime-corejs3/core-js-stable/array/from";
import _Symbol from "@babel/runtime-corejs3/core-js-stable/symbol";
import _getIteratorMethod from "@babel/runtime-corejs3/core-js/get-iterator-method";
import _getIterator from "@babel/runtime-corejs3/core-js/get-iterator";
import _bindInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/bind";
import _Symbol$toPrimitive from "@babel/runtime-corejs3/core-js-stable/symbol/to-primitive";
import _objectWithoutPropertiesLoose from "@babel/runtime-corejs3/helpers/objectWithoutPropertiesLoose";

function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }

function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[_Symbol$toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }

function _createForOfIteratorHelperLoose(o, allowArrayLike) { var _context6; var it; if (typeof _Symbol === "undefined" || _getIteratorMethod(o) == null) { if (_Array$isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } it = _getIterator(o); return _bindInstanceProperty(_context6 = it.next).call(_context6, it); }

function _unsupportedIterableToArray(o, minLen) { var _context5; if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = _sliceInstanceProperty(_context5 = Object.prototype.toString.call(o)).call(_context5, 8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return _Array$from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import _Object$assign from "@babel/runtime-corejs3/core-js-stable/object/assign";
import _Array$isArray from "@babel/runtime-corejs3/core-js-stable/array/is-array";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import _everyInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/every";
import _keysInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/keys";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/reduce";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import * as _ from "../util/lodash";
import withRefs from "./with-refs";
import capitalize from "../util/capitalize";
import { compose, withState, lifecycle, mapProps, withHandlers, defaultProps } from 'react-recompose';
export default function createComponent(blueprint) {
  if (blueprint === void 0) {
    blueprint = {};
  }

  var Component;
  validate(blueprint);
  Component = compose(create, injectPropTypes)(blueprint);
  Component = decorate(Component, blueprint);
  return Component;
} //TODO Error vs warning
//TODO enforce handler naming convention?

function validate(blueprint) {
  var _blueprint = blueprint;

  if (undefined) {
    if (!_blueprint.render) {
      throw new Error('blueprint.render is required');
    }

    if (!_blueprint.displayName) {
      throw new Error('displayName is required');
    }
  }

  return _blueprint;
}

function injectPropTypes(blueprint) {
  var _blueprint$defaultPro = blueprint.defaultProps,
      defaultProps = _blueprint$defaultPro === void 0 ? {} : _blueprint$defaultPro,
      _blueprint$propTypes = blueprint.propTypes,
      propTypes = _blueprint$propTypes === void 0 ? {} : _blueprint$propTypes,
      _blueprint$contextTyp = blueprint.contextTypes,
      contextTypes = _blueprint$contextTyp === void 0 ? {} : _blueprint$contextTyp;
  propTypes = _.mapValues(propTypes, function (val) {
    return val(defaultProps);
  }); // Not concerned with checking for defaults here so just passing in null

  contextTypes = _.mapValues(contextTypes, function (val) {
    return val(null);
  });
  return _Object$assign({}, blueprint, {
    propTypes: propTypes,
    defaultProps: defaultProps,
    contextTypes: contextTypes
  });
}

function create(_ref) {
  var render = _ref.render,
      displayName = _ref.displayName,
      defaultProps = _ref.defaultProps,
      propTypes = _ref.propTypes,
      contextTypes = _ref.contextTypes;

  var Component = function Component(props, context) {
    var _props = _.defaults({}, props, extractContext(context));

    return render(_props);
  };

  Component.displayName = displayName;
  Component.propTypes = propTypes;
  Component.contextTypes = contextTypes; // Component.unstable_handleError = function unstable_handleError(error) {
  //   console.log(`${displayName} Render Error: ${error}`)
  // };

  return Component;
}

var decorate = _.curry(function (Component, blueprint) {
  //Order matters
  return compose(_maybeWrap({
    blueprint: blueprint,
    schematic: 'defaultProps',
    hoc: defaultProps
  }), _setRefs(blueprint), _setState(blueprint), _maybeWrap({
    blueprint: blueprint,
    schematic: 'handlers',
    hoc: withHandlers
  }), _maybeWrap({
    blueprint: blueprint,
    schematic: 'lifecycles',
    hoc: lifecycle
  }), _debug(blueprint))(Component);
});

var _debug = _.curry(function (_ref2, Component) {
  var displayName = _ref2.displayName,
      debug = _ref2.debug;
  return debug && undefined ? lifecycle({
    componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
      deepDiff({
        props: prevProps,
        state: prevState
      }, {
        props: this.props,
        state: this.state
      }, displayName);
    }
  })(Component) : Component;
});

function isRequiredUpdateObject(o) {
  return _Array$isArray(o) || o && o.constructor === Object.prototype.constructor;
}

function deepDiff(o1, o2, p) {
  var notify = function notify(status) {
    var _context;

    if (_includesInstanceProperty(_context = ['avoidable?', 'avoidable!']).call(_context, status)) {
      console.warn("%cUpdate " + status, 'color: red');
    } else {
      console.log("%cUpdate " + status, 'color: green');
    }

    console.log('%cbefore', 'font-weight: bold', o1);
    console.log('%cafter ', 'font-weight: bold', o2);
  };

  if (!_.isEqual(o1, o2)) {
    var _context2, _context3;

    console.group(p);

    if (_everyInstanceProperty(_context2 = [o1, o2]).call(_context2, _.isFunction)) {
      notify('avoidable?');
    } else if (!_everyInstanceProperty(_context3 = [o1, o2]).call(_context3, isRequiredUpdateObject)) {
      notify('required.');
    } else {
      var keys = _.union(_keysInstanceProperty(_).call(_, o1), _keysInstanceProperty(_).call(_, o2));

      for (var _iterator = _createForOfIteratorHelperLoose(keys), _step; !(_step = _iterator()).done;) {
        var key = _step.value;
        deepDiff(o1[key], o2[key], key);
      }
    }

    console.groupEnd();
  } else if (o1 !== o2) {
    console.group(p);
    notify('avoidable!');

    if (_.isObject(o1) && _.isObject(o2)) {
      var _keys = _.union(_keysInstanceProperty(_).call(_, o1), _keysInstanceProperty(_).call(_, o2));

      for (var _iterator2 = _createForOfIteratorHelperLoose(_keys), _step2; !(_step2 = _iterator2()).done;) {
        var _key = _step2.value;
        deepDiff(o1[_key], o2[_key], _key);
      }
    }

    console.groupEnd();
  }
}
/*
 1) counter: 0 => props = { counter: 0, setCounter() }
 2) counter: {
      value: 0,
      updater: 'updateCounter'
    } => props = { counter: 0, updateCounter() }
 3) counter: {
      value: 0,
      updater(setCounter, props) {
        return {
          increment: () => setCounter(n => n + 1),
          decrement: () => setCounter(n => n - 1),
          reset: () => setCounter(0),
        }
      }
    } => props = { counter: 0, setCounter(), increment(), decrement(), reset() }
 */


var _setState = _.curry(function (_ref3, Component) {
  var state = _ref3.state;
  return _reduceInstanceProperty(_).call(_, _.toPairs(state), function (acc, keyVal) {
    var key = keyVal[0];
    var val = keyVal[1];
    var defaultSetter = "set" + capitalize(key);

    if (_.isObject(val)) {
      if (_.isString(val.updater)) {
        acc = withState(key, val.updater, val.value)(acc);
      } else {
        // This order seems backwards to me, but its what the docs say to do...so c'est la vie
        acc = compose(withState(key, defaultSetter, val.value), mapProps(function (_ref4) {
          var _context4;

          var setter = _ref4[defaultSetter],
              rest = _objectWithoutPropertiesLoose(_ref4, _mapInstanceProperty(_context4 = [defaultSetter]).call(_context4, _toPropertyKey));

          return _Object$assign({}, rest, val.updater(setter, rest));
        }))(acc);
      }
    } else {
      acc = withState(key, defaultSetter, val)(acc);
    }

    return acc;
  }, Component);
});

var _setRefs = _.curry(function (_ref5, Component) {
  var refs = _ref5.refs;

  if (_.isEmpty(refs) || _.isNil(refs)) {
    return Component;
  }

  var _refs = _.isString(refs) ? [refs] : refs;

  _refs = _reduceInstanceProperty(_).call(_, _refs, function (acc, ref) {
    acc[ref] = "set" + capitalize(ref);
    return acc;
  }, {});
  return withRefs(_refs)(Component);
});

var _maybeWrap = _.curry(function (_ref6, Component) {
  var blueprint = _ref6.blueprint,
      schematic = _ref6.schematic,
      hoc = _ref6.hoc;
  return !_.isEmpty(blueprint[schematic]) && !_.isNil(blueprint[schematic]) ? hoc(blueprint[schematic])(Component) : Component;
});

var contextDefaults = {
  isInverted: false
};

function extractContext(context) {
  return _.mapValues(context, function (value, key) {
    return value !== undefined ? value : contextDefaults[key];
  });
}
//# sourceMappingURL=component-factory.js.map